/**
 * useColorPalette — the master-account brand color palette for the DnD email
 * editor's color pickers (via api-v5 `GET /color-palettes`).
 *
 * Cached account-wide so every color control reuses one fetch. Colors are
 * grouped as 'primary' / 'standard' by the consumer.
 */
import { useQuery } from '@tanstack/react-query';
import { listColorPalette, type PaletteColor } from '@/services/colorPalettes.service';
import { useAuthStore } from '@/store/authStore';

export function useColorPalette() {
  const accountId = useAuthStore((s) => s.accountId);

  return useQuery<PaletteColor[]>({
    queryKey: ['color-palette', accountId],
    queryFn: listColorPalette,
    enabled: !!accountId,
    staleTime: 5 * 60_000,
    retry: false,
  });
}
